import React, { useState } from "react";
import { useTranslation } from "react-i18next";

import css from "./OrdersOrdersMenuComponent.module.css";
import { OrdersOrdersMenuSearchComponent } from "../OrdersOrdersMenuSearchComponent/OrdersOrdersMenuSearchComponent";
import { OrdersOrdersMenuDatesComponent } from "../OrdersOrdersMenuDatesComponent/OrdersOrdersMenuDatesComponent";
import { OrdersOrdersMenuMultiselect } from "../OrdersOrdersMenuMultiselect/OrdersOrdersMenuMultiselect";

const OrdersOrdersMenuComponent = ({ setIsOpenImportOrdersModal }) => {
  const [showFilters, setShowFilters] = useState(false);
  const { t } = useTranslation();

  const toggleFilters = () => {
    setShowFilters(!showFilters);
  };

  return (
    <div className={css.wrap}>
      <div className={css.firstBlock}>
        <OrdersOrdersMenuSearchComponent
          setIsOpenImportOrdersModal={setIsOpenImportOrdersModal}
        />

        <button className={css.toggleButton} onClick={toggleFilters}>
          <span>{t("filters")}</span>
          <span className={css.arrow}>{showFilters ? "▲" : "▼"}</span>
        </button>
      </div>

      <div
        className={`${css.secondBlock} ${
          showFilters ? css.showFilters : css.hideFilters
        }`}
      >
        <div className={css.blockType}>
          <OrdersOrdersMenuMultiselect />
        </div>

        <div className={css.dates}>
          <OrdersOrdersMenuDatesComponent />
        </div>
      </div>
    </div>
  );
};

export { OrdersOrdersMenuComponent };
